import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { Skeleton } from '@grandvisionhq/iris-ui';
import { useIntersectionObserver } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';

const ReactPlayer = /*#__PURE__*/ React.lazy(()=>import(/* webpackChunkName: "react-player" */ 'react-player')
);
const VideoLoader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "video__loader"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "video__skeleton"
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        height: "100%",
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "100%",
        rx: "5",
        fill: "currentColor"
    }))));
};
const Video = /*#__PURE__*/ React.memo(({ videoUrl , coverImage  })=>{
    const { getLabel  } = useIntl();
    const playerConfig = {
        height: '100%',
        width: '100%',
        controls: true,
        playing: true
    };
    const [playing, setPlaying] = React.useState(false);
    const [ref, inView] = useIntersectionObserver({
        rootMargin: '150px 0px',
        freezeOnceVisible: true
    });
    const handleClick = React.useCallback(()=>setPlaying(true)
    , [
        setPlaying
    ]);
    if (!videoUrl || !coverImage) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "video",
        "data-t": "video"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "video__wrapper",
        ref: ref
    }, playing ? /*#__PURE__*/ React.createElement("div", {
        className: "video__player"
    }, /*#__PURE__*/ React.createElement(React.Suspense, {
        fallback: /*#__PURE__*/ React.createElement(VideoLoader, null)
    }, /*#__PURE__*/ React.createElement(ReactPlayer, swcHelpers.extends({
        url: videoUrl
    }, playerConfig)))) : inView ? /*#__PURE__*/ React.createElement("div", {
        className: "video__image",
        style: {
            backgroundImage: `url(${coverImage.url || ''})`
        }
    }, /*#__PURE__*/ React.createElement("button", {
        "aria-label": getLabel('common.play'),
        className: "video__play-button",
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "play"
    }))) : null));
});

export { Video as default };
//# sourceMappingURL=Video.js.map
